import { useCallback } from 'react'

import { setToken } from '@/app/module/auth/helpers'
import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_ENABLE_TOTP } from '@/app/module/user/definitions'
import { getUser } from '@/app/module/user/store/actions'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useEnableTotp = () => {
  const dispatch = useAppDispatch()
  const [enable, res] = esApi.useSetUserTotpMutation()

  const enableTotp = useCallback(
    async (secret: string, passcode: string) => {
      try {
        const data = await enable({ body: { secret, passcode } }).unwrap()
        if (data.access) {
          setToken(data.access, '')
          await dispatch(getUser({ token: data.access }))
          dispatch(esApi.util.resetApiState())
        }
        return data
      } catch (error) {
        dispatch(
          createNotification({
            'enable-totp': {
              type: 'error',
              message: getErrorMessage(error, ERROR_ENABLE_TOTP),
            },
          }),
        )
        return undefined
      }
    },
    [dispatch, enable],
  )

  return [enableTotp, res] as const
}
